import { FC } from 'react';
import { Button, Typography } from '@mui/material';

import styles from './CustomSocialMediaButton.module.scss';

type CustomSocialMediaButtonProps = {
  text: string;
  icon: string;
  customStyle?: string;
  onClick: () => void | Promise<void>;
};

const CustomSocialMediaButton: FC<CustomSocialMediaButtonProps> = ({ text, icon, customStyle, onClick }) => (
  <Button
    id={styles.customSocialMediaBtn}
    variant="outlined"
    onClick={onClick}
    className={customStyle}
  >
    <img
      src={icon}
      className={styles.icon}
      alt="icon"
    />
    <Typography
      variant="h10Bold"
      className={styles.text}
    >
      {text}
    </Typography>
  </Button>
);

export default CustomSocialMediaButton;
